export interface MgpCardFormProps {
    name: string;
    onDownloadDoc: () => void;
    onPreviewDoc: () => void;
    headerElement: React.ReactNode;
    buttonName?: string;
    onClick?: () => void;
}


export default function MgpCardForm({name, onDownloadDoc, onPreviewDoc, headerElement, buttonName, onClick, ...props}: MgpCardFormProps) {

    const handleOnClick = (e: any) => {
        e.preventDefault();
        if (onClick) onClick();
    }

    const handleOnPreviewDoc = (e: any) => {
        e.preventDefault();
        onPreviewDoc();
    }
    
    return (
        <div className={`card-contrats box mt-sm`}>
            <div className='card' style={{gap: 0, flexWrap: "nowrap", display: 'flex', flexDirection: 'column'}}>
               {headerElement}

                <p style={{flex: 1}} className="fz-lg fw-medium mt-md mb-xl">{name}</p>

                <div className="grid-flex jc-center ta-center">
                    {buttonName &&
                            <div className="wrapper-cta-inline">
                                <button className="cta-bleu cta-small" style={{border: "1px solid #144196"}} onClick={(e) => handleOnClick(e)}>{buttonName}</button>
                            </div>
                    }
          
                    <div className="wrapper-cta-inline">
                        <a className="cta-blanc cta-small" href="#" onClick={(e) => handleOnPreviewDoc(e)}>Voir</a>
                    </div>
                </div>
            </div>
        </div>
      
    //     <div className="form-group mw-50 shadow-noir p-sm">
    //         {headerElement}
    //         <div className="m-y-md">
    //             <a className="download-bleu" target='_blank' title="Téléchargement du document" onClick={onDownloadDoc}>
    //                 <i className="icon-telechargement blanc"></i>
    //                 <span className="fw-medium" style={{minHeight: '4.5rem'}}>{name}</span>
    //             </a>
    //         </div>
    //       <div className="grid-flex jc-center ta-center">
    //         {buttonName &&
    //             <div className="wrapper-cta-inline">
    //                 <button className="cta-bleu cta-small" style={{border: "1px solid #144196"}} onClick={onClick}>{buttonName}</button>
    //             </div>
    //         }
          
    //         <div className="wrapper-cta-inline">
    //             <a className="cta-blanc cta-small" href="#" onClick={onPreviewDoc}>Voir</a>
    //         </div>
    //     </div>
          
    //   </div> 
    
    );
 
} 